import React from 'react';
import {
    UserPlusIcon,
    CalendarIcon,
    DocumentPlusIcon,
    ChatBubbleLeftRightIcon
} from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

export interface QuickActionItem {
    label: string;
    icon: React.ComponentType<any>;
    href?: string;
    onClick?: () => void;
}

interface QuickActionsWidgetProps {
    actions?: QuickActionItem[];
}

export const QuickActionsWidget: React.FC<QuickActionsWidgetProps> = ({ actions }) => {
    const defaultActions: QuickActionItem[] = [
        { label: 'Add Client', icon: UserPlusIcon, href: '/portal/clients/new' },
        { label: 'Schedule Meeting', icon: CalendarIcon, onClick: () => console.log('Schedule') },
        { label: 'Upload Document', icon: DocumentPlusIcon, onClick: () => console.log('Upload') },
        { label: 'Send Message', icon: ChatBubbleLeftRightIcon, href: '/portal/messages/new' }
    ];

    const displayActions = actions || defaultActions;

    return (
        <div className="bg-white portal-content-shadow rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
            <div className="grid grid-cols-2 gap-4">
                {displayActions.map((action, index) => {
                    const content = (
                        <>
                            <div className="p-3 bg-blue-50 rounded-lg group-hover:bg-blue-100 transition-colors">
                                <action.icon className="h-6 w-6 text-blue-600" />
                            </div>
                            <span className="text-sm font-medium text-gray-900 text-center">{action.label}</span>
                        </>
                    );

                    if (action.href) {
                        return (
                            <Link
                                key={index}
                                to={action.href}
                                className="flex flex-col items-center space-y-2 p-4 rounded-lg border border-gray-200 hover:border-blue-300 hover:shadow-sm transition-all group"
                            >
                                {content}
                            </Link>
                        );
                    }

                    return (
                        <button
                            key={index}
                            onClick={action.onClick}
                            className="flex flex-col items-center space-y-2 p-4 rounded-lg border border-gray-200 hover:border-blue-300 hover:shadow-sm transition-all group"
                        >
                            {content}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};
